import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage/LazyImage";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    desktopimage = "desktopimage",
    mobileimage = "mobileimage",
    alt = "alt",
    imgLink = "imgLink",
    openInNewTab = "openInNewTab",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.desktopimage]: string;
        [fields.mobileimage]: string;
        [fields.alt]: string;
        [fields.imgLink]: LinkFieldValue;
        [fields.openInNewTab]: boolean;
    };
}

export interface SurBannerStyles {
    ImageContainer?: InjectableCss;
    BannerImage?: LazyImageProps;
    ImageWrapper?:InjectableCss;
}

export const surBannerStyles: SurBannerStyles = {
    ImageContainer: {
        css: css`
            display: flex;
                a{
                width: 100%;
                span{
                    width: 100%;
                }
                }
  
            .bannerImage {
             
                width: 100%;
                img {
                    width: 100%;
                }
            }
        `,
    },
    BannerImage: {
        css: css`
            width: 100%;
            img {
                width: 100%;
                height: auto;
                aspect-ratio: 16/5;
                object-fit: cover;
            }
        `,
    },
};

const styles = surBannerStyles;

export const SurBanner: FC<OwnProps> = ({ fields }) => {
    const { url } = useGetLink(fields.imgLink);
    return (
        <StyledWrapper {...styles.ImageContainer}>
            {url && url?.length > 0?(
            <Link href={url} target={fields.openInNewTab ? "_blank" : "_self"}>
                <picture className="bannerImage">
                    <source media="(max-width:768px)" srcSet={fields.mobileimage} />
                    <img src={fields.desktopimage} alt={fields.alt} />
                </picture>
            </Link>):(
                
                <picture className="bannerImage" >
                <source media="(max-width:768px)" srcSet={fields.mobileimage} />
                <img src={fields.desktopimage} alt={fields.alt} />
            </picture>
           
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SurBanner,
    definition: {
        group: "Basic",
        icon: "image",
        displayName: "SurBanner",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.desktopimage,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Desktop Image",
            },

            {
                fieldType: "Translatable",
                name: fields.mobileimage,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Mobile Image",
            },
            {
                name: fields.alt,
                displayName: "Alt Text",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "text tip",
                placeholder: "text placeholder",
            },
            {
                name: fields.imgLink,
                displayName: "Image Link",
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
            },
            {
                name: fields.openInNewTab,
                displayName: "Open In A New Tab",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
